// extracted by mini-css-extract-plugin
export default {"panel":"SlidingPanel_panel__1dzMY","active":"SlidingPanel_active__6kGrn"};